module.exports = __webpack_public_path__ + "media/images/city/035-abu-simbel-c9217bfe1b8c904ac1957ebd7b50d5d0.svg";